export class Kmi {
    id: number;
    KMIEmail: string;
    KMIPhone: string;
}